export enum InvoicesOlsaActionType {
  FETCH_INVOICES_OLSA = 'FETCH_INVOICES_OLSA',
  FETCH_SELECTED_INVOICE_OLSA = 'FETCH_SELECTED_INVOICE_OLSA',
  FETCH_DOCUMENT_TYPES = 'FETCH_DOCUMENT_TYPES',
  DOWNLOAD_INVOICEOLSA_BULK = 'DOWNLOAD_INVOICEOLSA_BULK'
}
